import { useDateFormat } from "@vueuse/core";

// UserStatus::Active of the tiktok service
const ACTIVE_STATUS = "active";

/**
 * Same status matrix as statusNumberConfig, keyed on a tiktok account instead
 * of a number. The tariff and integration fields match, but the status itself
 * comes from the tiktok UserStatus enum: 'active' once the account is connected
 * through OAuth, 'inactive' after it is disconnected — not the 'Activated' the
 * messenger services send.
 *
 * @param {Object} account - The account row coming from /api/tiktok/accounts/paginate.
 * @param {string} account.status - 'active' | 'inactive'
 * @param {string} account.tariff_end_date
 * @param {boolean} account.prepayment_enabled
 * @param {Array} account.integrations
 * @param {boolean} account.visibility
 *
 * @return {{status: string, buttonText: string}}
 */
export default function statusAccountConfig(account) {
    let status, buttonText;

    const now = new Date();
    const endTariff = new Date(account.tariff_end_date);
    const isActiveTariff =
        useDateFormat(endTariff, "YYYYMMDD").value -
            useDateFormat(now, "YYYYMMDD").value >=
        0;

    const hasIntegration = account.integrations?.length > 0;

    if (account.status === ACTIVE_STATUS) {
        if (isActiveTariff) {
            if (hasIntegration) {
                status = account.prepayment_enabled ? "active_pre" : "active";
            } else {
                status = "waiting_for";
            }
        } else {
            status = "number_disable";
        }

        buttonText = status === "error" ? "help_button" : "pay_button";
    } else if (isActiveTariff || !account.tariff_end_date) {
        status = "requires_activation";
        buttonText = "activation_button";
    } else {
        status = "number_disable";
        buttonText = "pay_button";
    }

    if (!account.visibility) {
        buttonText = "return";
    }

    return { status, buttonText };
}
